module.exports = __webpack_public_path__ + "media/application/images/facebook-5226c2caa66844edcbda57e97866539c.svg";